import React, { Component } from "react"
import Svg from "../_svgs/svg"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { handleClickTracking } from "../../helpers/tracking"

export default class AccordionWithLink extends Component {
  handleAccordion = (event, classname) => {
    let elem = event.currentTarget
    this.showHideContent(elem, classname)
  }

  showHideContent = (elem, classname) => {
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  componentDidMount() {
    if (window.location.hash?.replace("#", "") === this.props.anchorId) {
      // waits until paint is done
      requestAnimationFrame(() => {
        this.openAccordionFromAnchor()
      })
    }
  }

  openAccordionFromAnchor = () => {
    const accordion = document.getElementById(this.props.anchorId)
    const accordionTrigger = accordion.querySelector(".accordion-trigger")
    if (accordionTrigger) {
      this.showHideContent(accordionTrigger, ".contentWrapper")
    }
  }

  render() {
    const { linkTarget, linkText, linkTracking, linkUrl } = this.props.link
    const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)
    return (
      <div className="accordionitem" id={this.props.anchorId}>
        <h4 className="accordion-trigger" onClick={(e) => this.handleAccordion(e, ".contentWrapper")}>
          {this.props.headline}
        </h4>
        <div className="contentWrapper show-hide">
          <div className="top-border"></div>
          <div className="maintext">
            {ReactHtmlParser(this.props.text)}
            {linkUrl && linkText ? (
              <a className="bottom-link" href={linkUrl} onClick={() => handleClickTracking(linkTracking)} target={target}>
                <Svg iconName={"arrowright-slim"} renderContainer={false} />
                <span>{linkText}</span>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    )
  }
}
